import { render, staticRenderFns } from "./CopyAssetsDestinationView.vue?vue&type=template&id=4daafd18&scoped=true"
import script from "./CopyAssetsDestinationView.vue?vue&type=script&lang=js"
export * from "./CopyAssetsDestinationView.vue?vue&type=script&lang=js"
import style0 from "./CopyAssetsDestinationView.vue?vue&type=style&index=0&id=4daafd18&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daafd18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4daafd18')) {
      api.createRecord('4daafd18', component.options)
    } else {
      api.reload('4daafd18', component.options)
    }
    module.hot.accept("./CopyAssetsDestinationView.vue?vue&type=template&id=4daafd18&scoped=true", function () {
      api.rerender('4daafd18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/CopyAssetsDestinationView.vue"
export default component.exports